const initialState = () => {
  return {
    isFirstTransition: true
  }
}
export default initialState



// WEBPACK FOOTER //
// ./src/store/modules/onboarding/initialState.js